export default "__VITE_ASSET__IPgKb6zt__"